import React, { useState, useRef , useEffect } from 'react';
import { AppBar, Toolbar, IconButton, Button, Menu, MenuItem, Drawer, List, ListItemButton, ListItemText, Grid, 
         useMediaQuery, Collapse, Popover, useTheme, Box, Typography, Link } from '@mui/material';
import { Menu as MenuIcon, LinkedIn as LinkedInIcon, ExpandLess, ExpandMore, Padding, Margin} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/logos/phyelements_logo.png';
import newlaunch from "../../assets/images/site/newlaunch.png";
import './PhyelementsMain.css';

function PhyelementsMain() {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = useState(null);
  const [submenuVLSI, setSubmenuVLSI] = useState(null);
  const [submenuAi, setSubmenuAi] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [vlsiOpen, setVlsiOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);

  const [servicesAnchor, setServicesAnchor] = useState(null);
  const [vlsiAnchor, setVlsiAnchor] = useState(null);

  const vlsiTimerRef = useRef(null);
  const aiTimerRef = useRef(null);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleServicesClick = () => {
    setServicesOpen(!servicesOpen);
  };

  const handleProductsClick = () => {
    setProductsOpen(!productsOpen);
  };

  const handleVlsiClick = () => {
    setVlsiOpen(!vlsiOpen);
  };

  const handleAiClick = () => {
    setAiOpen(!aiOpen);
  };

  const handleloginButton = () =>{
    navigate('/hrms/login')
  }

  const handleContact = () =>{
    navigate('/contact');
  }

  const handleServicesMenuClick = (event) => {
    setServicesAnchor(event.currentTarget);
  };

  const handleServicesMenuClose = () => {
    setServicesAnchor(null);
    setVlsiAnchor(null);
  };

  const handleVlsiHover = (event) => {
    setVlsiAnchor(event.currentTarget);
  };

  const handleVlsiClose = () => {
    setVlsiAnchor(null);
  };
  
  const drawerContent = (
    <List className="drawer">
      <ListItemButton onClick={() => navigate('/')}>
        <ListItemText primary="HOME" />
      </ListItemButton>
      <ListItemButton onClick={handleServicesClick}>
        <ListItemText primary="SERVICES" />
        {servicesOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton> 
      <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton onClick={handleVlsiClick}>
            <ListItemText primary="VLSI SEMICONDUCTORS" />
            {vlsiOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          {/* <Collapse in={vlsiOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton onClick={() => navigate('/services/designlayout')}>
                <ListItemText primary="Design & Layout Capabilities" />
              </ListItemButton>
              <ListItemButton onClick={() => navigate('/services/physicaldesign')}>
                <ListItemText primary="Physical Design & Verification" />
              </ListItemButton>
              {/* <ListItemButton onClick={() => navigate('/services/analoglayout')}>
                <ListItemText primary="ANALOG LAYOUT" />
              </ListItemButton> */}            
          {/* <ListItemButton onClick={handleAiClick}>
            <ListItemText primary="AI / ML" />
            {aiOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
          <Collapse in={aiOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton>
                <ListItemText primary="Deep Learning" />
              </ListItemButton>
              <ListItemButton>
                <ListItemText primary="Natural Language Processing" />
              </ListItemButton>
              <ListItemButton>
                <ListItemText primary="Computer Vision" />
              </ListItemButton>
            </List>
          </Collapse> */}
        </List>
      </Collapse>
      <ListItemButton onClick={handleProductsClick}>
        <ListItemText primary="PRODUCTS" />
        {productsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton> 
       <Collapse in={productsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton onClick={() => window.open('https://www.phytool.com', '_blank')}>
            <ListItemText primary="PHYtool - Diagramming tool" primaryTypographyProps={{className: "sniglet-font-text"}} />            
          </ListItemButton>
        </List>
      </Collapse>

      <ListItemButton onClick={() => navigate('/careers')}>
        <ListItemText primary="CAREERS" />
      </ListItemButton>
      <ListItemButton onClick={handleContact}>
        <ListItemText primary="CONTACT" />
      </ListItemButton>
      <ListItemButton onClick={handleloginButton}>
        <ListItemText primary="PHYE-HRMS LOGIN" />
      </ListItemButton>
      <ListItemButton>
      <LinkedInIcon/>
      </ListItemButton>
    </List>
  );

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setSubmenuVLSI(null);
    setSubmenuAi(null);
  };

  const handleSubmenuMouseLeave = () => {
    setSubmenuVLSI(null);
    setSubmenuAi(null);
  };

  const handleVLSIMenuLeave = () => {
    vlsiTimerRef.current = setTimeout(() => setSubmenuVLSI(null), 200);
  };

  const handleAIMenuLeave = () => {
    aiTimerRef.current = setTimeout(() => setSubmenuAi(null), 200);
  };

  const handleVLSIMenuHover = (event) => {
    if (!submenuVLSI) {
      setSubmenuVLSI(event.currentTarget);
      setSubmenuAi(null);
    }
  };

  const handleAIMenuHover = (event) => {
    if (!submenuAi) {
      setSubmenuAi(event.currentTarget);
      setSubmenuVLSI(null);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSubmenuVLSI(null);
    setSubmenuAi(null);
  };

  useEffect(()=>{
    localStorage.clear();
    sessionStorage.clear();
  },[])

  return (
    <div>
      <AppBar position="static" className="appbar">
        <Toolbar>
          <Grid container justifyContent="space-between" alignItems="center">
            <img src={Logo} alt="Logo" className="logo" />
            {isMobile ? (
              <IconButton edge="end" color="inherit" aria-label="menu" onClick={toggleDrawer(true)}>
                <MenuIcon />
              </IconButton>
            ) : (
              <Grid item>
                <Button className="menu-button" onClick={() => navigate('/')}>HOME</Button>
                <Button
                    onClick={handleServicesMenuClick}
                    className="menu-button"
                  >
                    SERVICES
                    {servicesAnchor ? <ExpandLess className="menu-icon" /> : <ExpandMore className="menu-icon" />}
                  </Button>
                <Menu
                  id="services-menu"
                  anchorEl={servicesAnchor}
                  open={Boolean(servicesAnchor)}
                  onClose={handleServicesMenuClose}
                  onMouseLeave={handleServicesMenuClose}
                >
                  <MenuItem
                    onMouseEnter={handleVlsiHover}
                    onMouseLeave={handleVlsiClose}
                  >
                    VLSI SEMICONDUCTORS
                    {submenuVLSI ? <ExpandLess className="menu-icon" /> : <ExpandMore className="menu-icon" />}
                      <Popover
                        id="vlsi-popover"
                        open={Boolean(vlsiAnchor)}
                        anchorEl={vlsiAnchor}
                        onClose={handleVlsiClose}
                        onMouseLeave={handleVlsiClose}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'left',
                        }}
                      >
                        <MenuItem onClick={() => navigate('/services/designlayout')}>Design & Layout Capabilities</MenuItem>
                        {/* <MenuItem>ASIC</MenuItem> */}
                        <MenuItem onClick={() => navigate('/services/physicaldesign')}>Physical Design & Verification</MenuItem>
                        {/* <MenuItem onClick={() => navigate('/services/analoglayout')}>ANALOG LAYOUT</MenuItem> */}
                    </Popover>
                  </MenuItem>

                  {/* <MenuItem
                    onMouseEnter={handleAIMenuHover}
                    onMouseLeave={handlePopoverClose}
                  >
                    AI / ML
                    {submenuAi ? <ExpandLess className="menu-icon" /> : <ExpandMore className="menu-icon" />}
                    <Popover
                      id="ai-popover"
                      open={Boolean(submenuAi)}
                      anchorEl={submenuAi}
                      onClose={handlePopoverClose}
                      onMouseLeave={handlePopoverClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <MenuItem onClick={handlePopoverClose}>Deep Learning</MenuItem>
                      <MenuItem onClick={handlePopoverClose}>Natural Language Processing</MenuItem>
                      <MenuItem onClick={handlePopoverClose}>Computer Vision</MenuItem>
                    </Popover>
                  </MenuItem> */}
                </Menu>
                <Button
                  onClick={handleMenuClick}
                  className="menu-button"
                >
                  PRODUCTS
                  {anchorEl ? <ExpandLess className="menu-icon" /> : <ExpandMore className="menu-icon" />}
                </Button>
                <Menu
                  id="products-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  onMouseLeave={handleMenuClose}
                >
                  <MenuItem
                    onMouseEnter={handleVLSIMenuHover}
                    onMouseLeave={handlePopoverClose}
                    
                  >                    
                    <Link href="https://phytool.com/" underline="none" rel="noopener" target="_blank" className="sniglet-font-text">
                     PHYtool -Diagramming tool
                    </Link>
                  </MenuItem>
                  
                  {/* <MenuItem
                    onMouseEnter={handleAIMenuHover}
                    onMouseLeave={handlePopoverClose}
                  >
                    AI / ML
                    {submenuAi ? <ExpandLess className="menu-icon" /> : <ExpandMore className="menu-icon" />}
                    <Popover
                      id="ai-popover"
                      open={Boolean(submenuAi)}
                      anchorEl={submenuAi}
                      onClose={handlePopoverClose}
                      onMouseLeave={handlePopoverClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                    >
                      <MenuItem onClick={handlePopoverClose}>Deep Learning</MenuItem>
                      <MenuItem onClick={handlePopoverClose}>Natural Language Processing</MenuItem>
                      <MenuItem onClick={handlePopoverClose}>Computer Vision</MenuItem>
                    </Popover>
                  </MenuItem> */}
                </Menu>
                <Button className="menu-button" onClick={() => navigate('/careers')}>CAREERS</Button>
                <Button className="menu-button" onClick={handleContact}>CONTACT</Button>
                <Button className="menu-button" onClick={handleloginButton}>PHYE-HRMS LOGIN</Button>
                <Button className="menu-button"><LinkedInIcon fontSize='large'/></Button>
              </Grid>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
      <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
        {drawerContent}
      </Drawer>
    </div>
  );
}

export default PhyelementsMain;
